import $http from '../../axios';
import {Notification, MessageBox} from 'element-ui';
import {getApiDomain} from '../../util/domains';

export async function getProducts({commit, state}, data) {
    let selected_branchoffice_warehouse = JSON.parse(
        localStorage.selected_branchoffice_warehouse
    );
    let params = {
        params: {
            branchoffice_warehouse_id: selected_branchoffice_warehouse,
        }
    };

    commit('setPreloader', true);

    await $http.get(`/api/despachos-productos/${data.id}`, params)
        .then((response) => {
            response.data.data.map(el => {
                if (el.product.inventory.length == 0) {
                    el.product.inventory[0] = {location: null};
                }
            });
            data.row.documents_products = response.data.data;
            commit('setPreloader', false);
        }).catch((error) => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit('setPreloader', false);
        });
}

/**
 * Finalizar packing
 */
export async function finalizePacking({commit, state, dispatch}) {

    commit('setPreloader', true);

    await $http.post(`/api/finalizar-packing/`, state.invoice)
        .then((response) => {
            commit('setPreloader', false);
            Notification.success({
                title: 'Muy bien!',
                message: response.data.message,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit('setModalPackingShow', false);
            dispatch('fetchDespatchInvoice');
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: error.response.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

/**
 * Generar pdf Stickers
 */
export async function generatePdfStickers({state}) {

    const link = getApiDomain();

    await $http({
        url: '/api/descargar-pdf-stickers/' + state.invoice.id + '?link=' + link + '&number_stickers=' + state.invoice.number_stickers,
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'stickers.pdf');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

export async function getStates({commit, state}) {
    if (!state.states.length) {

        commit('setPreloader', true);

        await $http.get(`/api/parametros-por-codigo/STDPA`)
            .then((response) => {
                commit('setStates', response.data.data);

                if (!!response.data.data[0]) {
                    commit('setStateDespatchIdFilters', response.data.data[0].code_parameter);
                }

                commit('setPreloader', false);
            })
            .catch((error) => {
                commit('setPreloader', false);
                console.error(error);
            });
    }
}


export async function fetchDespatchInvoice({commit, state}) {

    let params = state.params;

    params.branchoffice_id = JSON.parse(localStorage.selected_branchoffice);
    params.branchoffice_warehouse_id = JSON.parse(localStorage.selected_branchoffice_warehouse);

    commit('setPreloader', true);

    await $http.get(`/api/listar-facturas-despachos-packing`, {params})
        .then(response => {
            commit('setInvoices', response.data.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });

    state.tableDespatch.loading = false;
}

//Obtener los parametros de una tabla
export async function fetchParametersZone({commit, rootState}) {
    await $http
        .get(`/api/parametros?paramtable_id=6`)
        .then(response => {
            commit('setParametersZone', response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box'
            });
        });
}

//Obtener los transportadores
export async function fetchConveyor({commit, rootState}) {

    commit('setPreloader', true);

    await $http
        .get(`/api/lista-transportadores`)
        .then(response => {
            commit('setconyevors', response.data);
            commit('setPreloader', false);
        })
        .catch(error => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box'
            });
        });
}

export async function updateDespatchInvoice({commit, state, dispatch}, data) {

    commit('setPreloader', true);

    await $http
        .put(`/api/despachos/${data.id}`, data)
        .then(response => {
            commit('setPreloader', false);
            Notification.success({
                title: 'Exito!',
                message: 'Registro actualizado.',
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            // dispatch('fetchDespatchInvoice')
        })
        .catch(error => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: 'Error al actualizar',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

// Actualizamos el registro.
export async function updateDespatchStatus({commit, state, dispatch}, state_code) {

    commit('setPreloader', true);

    const despatch = state.invoices.data.filter(value => {
        return value.pack_off;
    });

    await $http.put(`/api/despachos-masivo-packing/${state_code}`, {despatch})
        .then((response) => {
            commit('setPreloader', false);
            Notification.success({
                title: 'Éxito!',
                message: response.data.message,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            dispatch('fetchDespatchInvoice');
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: 'Error al actualizar',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

// Actualizamos el registro.
export async function updateDespatchStatusOA({commit, state, dispatch}) {
    var despatch = state.tableDespatch.data.filter(value => {
        return value.pack_off;
    });

    var productLot = state.tableDocumentsProductsLot.data;
    var send = {
        despatch,
        productLot
    };

    send.give_back = state.tableDespatch.options.state === null ? false : true;
    send.admin_operations = true;

    try {
        var response = await $http.put(`/api/despachos-masivo`, send);
        commit('setPreloader', false);
        Notification.success({
            title: 'Exito!',
            message: response.data,
            type: 'success',
            duration: 1500,
            customClass: 'notification-box'
        });
        dispatch('fetchDespatchInvoice');
    } catch (error) {
        commit('setPreloader', false);
        Notification.error({
            title: 'Error!',
            message: 'Error al actualizar',
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
    }
}

export async function fetchContacts({
                                        commit,
                                        state
                                    }, requestParameters = {
    params: state.paramsquery
}) {

    commit('setPreloader', true);

    await $http.get('/api/terceros', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data.data);
            commit('setPreloader', false);

        })
        .catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: 'Error',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            // commit('contactError', error.message)
        });
}

export async function generatePdf({commit, state}) {
    let selected_branchoffice = JSON.parse(localStorage.selected_branchoffice);
    let selected_branchoffice_warehouse = JSON.parse(
        localStorage.selected_branchoffice_warehouse
    );
    var despatch = state.tableDespatch.data.filter(value => {
        return value.pack_off;
    });

    var validate_pro = 0;
    var validate = false;
    var row;

    despatch.forEach(element => {
        if (element.documents_information != null) {
            if (element.documents_information.protractor == null) {
                validate_pro++;
            }
        }
    });

    despatch = despatch.map(function (item) {
        return item.id;
    });
    var send = {
        // date: state.tableDespatch.options.date,
        state: state.tableDespatch.options.state,
        fromDate: state.tableDespatch.options.date[0],
        toDate: state.tableDespatch.options.date[1],
        branchoffice_id: selected_branchoffice,
        model_id: 1,
        selected_branchoffice_warehouse: selected_branchoffice_warehouse,
        contact_branchoffice_id: state.tableDespatch.options.contact_branchoffice_id,
        despatch
    };

    if (validate_pro > 0) {
        await MessageBox.alert(
            'Hay facturas sin Transportador. ¿Desea Continuar?',
            'Error',
            {
                // dangerouslyUseHTMLString: true,
                confirmButtonText: 'Continual',
                cancelButtonText: 'Cancelar',
                type: 'warning'
                // customClass: 'notification-error'
            }
        )
            .then(() => {
                validate = true;
            })
            .catch(() => {
                validate = false;
            });
    } else {
        validate = true;
    }

    if (validate) {
        try {
            var response = await $http.get(`/api/pdfdespatch`, {
                params: send,
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Transportador.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        }
    }
}

export async function generatePickin({commit, state}) {
    let selected_branchoffice = JSON.parse(localStorage.selected_branchoffice);
    let selected_branchoffice_warehouse = JSON.parse(
        localStorage.selected_branchoffice_warehouse
    );
    var despatch = state.tableDespatch.data.filter(value => {
        return value.pack_off;
    });
    despatch = despatch.map(function (item) {
        return item.id;
    });
    var send = {
        // date: state.tableDespatch.options.date,
        state: state.tableDespatch.options.state,
        fromDate: state.tableDespatch.options.date[0],
        toDate: state.tableDespatch.options.date[1],
        branchoffice_id: selected_branchoffice,
        model_id: 1,
        selected_branchoffice_warehouse: selected_branchoffice_warehouse,
        contact_branchoffice_id: state.tableDespatch.options.contact_branchoffice_id,
        despatch,
        packing: true
    };

    try {
        var response = await $http.get(`/api/pdfpickin`, {
            params: send,
            responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'pickin.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
    }
}

//Actualizar un registro uno a uno.
export async function updateDespatchStatusOne(
    {commit, state, dispatch},
    data
) {
    try {
        var response = await $http.put(`/api/despachos-cambiar-estado/${data.id}`, {
            state: data.state
        });
        Notification.success({
            title: 'Exito!',
            message: response.data,
            type: 'success',
            duration: 1500,
            customClass: 'notification-box'
        });
        dispatch('fetchDespatchInvoice');
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: 'Error al actualizar',
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
    }
}

export async function updatelocation({state}) {
    let selected_branchoffice_warehouse = JSON.parse(
        localStorage.selected_branchoffice_warehouse
    );

    var params = {
        branchoffice_warehouse: selected_branchoffice_warehouse,
        product: state.params.product,
        location: state.params.location
    };

    try {
        var response = await $http.put(`/api/actualizar-localizacion`, params);
        if (response.data.status) {
            Notification.success({
                title: 'Exito!',
                message: response.data.message,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
        } else {
            Notification.error({
                title: 'Error!',
                message: response.data.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        }
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: 'Error al actualizar',
            type: 'error',
            duration: 1500,
            customClass: 'notification-box'
        });
    }
}

export async function generateexcel({commit, state}) {

    let params = state.params;

    params.branchoffice_id = JSON.parse(localStorage.selected_branchoffice);
    params.branchoffice_warehouse_id = JSON.parse(localStorage.selected_branchoffice_warehouse);

    // Definimos las opciones
   /* let params = {
        params: {
            page: state.tableDespatch.options.currentPage,
            // perPage: state.tableDespatch.options.perPage,
            search: state.tableDespatch.options.search,
            //date': null,
            zone_id: state.tableDespatch.options.zone_id,
            contact_id: state.tableDespatch.options.contact_id,
            state: state.tableDespatch.options.state,
            branchoffice_id: selected_branchoffice,
            branchoffice_warehouse_id: selected_branchoffice_warehouse,
            contact_branchoffice_id: state.tableDespatch.options.contact_branchoffice_id,
            model_id: 1,
            guide: state.tableDespatch.options.guide,
            protractor: state.tableDespatch.options.protractor,
            perPage: state.tableDespatch.pagination.total,
            packing: true
        }
    };
    if (state.tableDespatch.options.date.length > 0) {
        params.params.fromDate = state.tableDespatch.options.date[0];
        params.params.toDate = state.tableDespatch.options.date[1];
    }*/

    await $http({
        url: `/api/exceldespachos`,
        method: 'GET',
        params: params,
        responseType: 'blob' // important
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'despachos.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function generateexcelPickin({commit, state}) {
    let selected_branchoffice = JSON.parse(localStorage.selected_branchoffice);
    let selected_branchoffice_warehouse = JSON.parse(
        localStorage.selected_branchoffice_warehouse
    );
    var despatch = state.tableDespatch.data.filter(value => {
        return value.pack_off;
    });
    despatch = despatch.map(function (item) {
        return item.id;
    });
    var send = {
        // date: state.tableDespatch.options.date,
        state: state.tableDespatch.options.state,
        fromDate: state.tableDespatch.options.date[0],
        toDate: state.tableDespatch.options.date[1],
        branchoffice_id: selected_branchoffice,
        model_id: 1,
        selected_branchoffice_warehouse: selected_branchoffice_warehouse,
        contact_branchoffice_id: state.tableDespatch.options.contact_branchoffice_id,
        despatch,
        packing: true
    };

    await $http({
        url: `/api/excelpickin`,
        method: 'GET',
        params: send,
        responseType: 'blob' // important
    })
        .then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'pickin.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}


export async function printLabels_({commit, state}, link) {
    let selected_branchoffice = JSON.parse(localStorage.selected_branchoffice);
    let selected_branchoffice_warehouse = JSON.parse(
        localStorage.selected_branchoffice_warehouse
    );
    var despatch = state.tableDespatch.data.filter(value => {
        return value.pack_off;
    });
    despatch = despatch.map(function (item) {
        return item.id;
    });
    let params = {
        params: {
            page: state.tableDespatch.options.currentPage,
            perPage: state.tableDespatch.options.perPage,
            search: state.tableDespatch.options.search,
            //date': null,
            zone_id: state.tableDespatch.options.zone_id,
            contact_id: state.tableDespatch.options.contact_id,
            state: state.tableDespatch.options.state,
            branchoffice_id: selected_branchoffice,
            branchoffice_warehouse_id: selected_branchoffice_warehouse,
            contact_branchoffice_id: state.tableDespatch.options.contact_branchoffice_id,
            model_id: 1,
            guide: state.tableDespatch.options.guide,
            protractor: state.tableDespatch.options.protractor,
            consecutive: state.tableDespatch.options.consecutive,
            link: link,
            despatch
        }
    };
    if (state.tableDespatch.options.date.length > 0) {
        params.params.fromDate = state.tableDespatch.options.date[0];
        params.params.toDate = state.tableDespatch.options.date[1];
    }

    await $http({
        url: `/api/excel-etiquetas`,
        method: 'GET',
        params: params.params,
        responseType: 'blob' // important
    })
        .then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Impresion-Stickers.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchDeleteProduct({commit, state},document_product_id){
    await $http
        .delete(`/api/document-product-packing/${document_product_id}`)
        .then(response => {
            Notification.success({
                title: "Success!",
                message: "Producto Eliminado correctamente Correctamente",
                type: "success",
                duration: 3000,
                customClass: "notification-box"
            });
            commit("deleteDocumentProdcut", document_product_id);
            commit("setDocumentProductModal", null);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchupdatePacking({commit, state,dispatch},document_product){
    state.loading.module = true
    await $http.post(`/api/documento-packing/${document_product.document_id}`, document_product).then((response) => {
        state.loading.module = false
        dispatch('get',response.data.id);
        Notification.success({
            title: "Success!",
            message: "Documento Actualizado Correctamente",
            type: "success",
            duration: 3000,
            customClass: "notification-box"
        });
    }).catch(error => {
        let message = ''
        if (error.response && error.response.data && error.response.data.message){
            message = error.response.data.message
        }
        state.loading.module = false
        Notification.error({
            title: "Error!",
            message: message? message : "Error Al Actualizar El Documento",
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });
}

/**
 * Request tipo PUT para actualizar document_product.
 * @author Jhon García
 */
export async function updateDocumentProduct({commit, state}, id) {
    await $http
        .put(`/api/actualizar-alistado/${id}`)
        .then(response => {
            Notification.success({
                title: "Muy bien!",
                message: response.data.message,
                type: "success",
                duration: 3000,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            console.error(error);

            Notification.error({
                title: "Error!",
                message: "Error al actualizar el producto",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/despatch-packing/actions.js